import React from 'react';
import { useTranslator } from 'tradera/lang/translate';

export const PaymentMethodName = ({ paymentMethod }) => {
    const { t } = useTranslator();

    const getName = () => {
        if (paymentMethod?.indexOf('PaynovaInstallments') === 0)
            return t('checkout_paid_paynova_installments');

        switch (paymentMethod) {
            case 'Mastercard':
            case 'Visa':
            case 'VisaMasterCard':
            case 'Card':
                return t('syi_payment_option_VisaMasterCard');
            case 'Paynova':
                return t('syi_payment_option_Paynova');
            case 'PayPal':
                return t('syi_payment_option_PayPal');
            case 'SwishHandel':
                return t('syi_payment_option_Swish');
            case 'ApplePay':
                return t('syi_payment_option_ApplePay');
            case 'GooglePay':
                return t('syi_payment_option_GooglePay');
            case 'Klarna':
                return t('syi_payment_option_Klarna');
            case 'PaynovaDirectInvoice':
                return t('checkout_paid_paynova_invoice');
            case 'Invoice':
                return t('syi_payment_option_balance');
            default:
                return null;
        }
    };

    return <span>{getName()}</span>;
};
